import { cargoServices } from "./db/cargoServices";

export const getCompanies = () => {
  return {
    hits: {
      data: cargoServices,
    },
  };
};

export const getCompanyProfile = (id) => {
  return {
    hits: {
      data: cargoServices.find((company) => company.id === +id),
    },
  };
};

export const getCompaniesByQuery = (query) => {
  const { where, from, keyword } = query;

  if (keyword)
    return {
      hits: {
        data: cargoServices.filter(({ title }) =>
          title.toLowerCase().includes(keyword.toLowerCase())
        ),
      },
    };

  return {
    hits: {
      data: cargoServices.filter(({ attributes: [from_city, to_city] }) => {
        console.log(from_city, from, to_city, where);
        return from_city.value.includes(from) && to_city.value.includes(where);
      }),
    },
  };
};

export const sortCompanies = (companies, sortBy) => {
  if (sortBy === "price") {
    return {
      hits: {
        data: companies.sort(
          (first, sec) => +sec.records[0].price - +first.records[0].price
        ),
      },
    };
  }
  if (sortBy === "rating") {
    return {
      hits: {
        data: companies.sort((first, sec) => +sec.rating - +first.rating),
      },
    };
  }

  if (sortBy === "speed") {
    return {
      hits: {
        data: companies.sort(
          (first, sec) =>
            sec.attributes[3].value +
            sec.attributes[4].value -
            (first.attributes[3].value + first.attributes[4].value)
        ),
      },
    };
  }

  return companies;
};
